export const Settings = {
  REEL_COUNT: 5,
  SYMBOLS_VISIBLE: 4,
  SYMBOL_WIDTH: 144, // Maximum symbol width
  SYMBOL_HEIGHT: 134, // Maximum symbol height

  APP: {
    RGS_PROVIDER: "Dmon",
    GAME_NAME: "Noble Fruits",
    UI_THEME: "primary",
  },
};

// Game layout configuration - pre-generated arrays for reel and symbol indices
export const GAME_LAYOUT = {
  REEL_COUNT: Settings.REEL_COUNT,
  SYMBOLS_VISIBLE: Settings.SYMBOLS_VISIBLE,
  SYMBOL_INDICES: Array.from(
    { length: Settings.SYMBOLS_VISIBLE },
    (_, idx) => idx,
  ),
  REEL_INDICES: Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx),
  MIDDLE_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2), // Middle reel index (for 5 reels = 2)
  SECOND_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2) - 1, // Second reel index (for 5 reels = 1)
};

export const APP_VERSION = "21.01.2026 - 15:40";

// Stage dimensions - centralized configuration
export const STAGE_DIMENSIONS = {
  MAX_WIDTH: 3840, // Maximum stage width for UI constraint and background scaling
  MAX_HEIGHT: 2580, // Maximum background height (for reference)
};
